export default __webpack_public_path__ + "static/plant-c9d20e1fd6c273712f9d67e427177cc7.png";